/* istanbul ignore file */
import { SunlightTimeDay } from 'types/sunlightTimes';
import { convertToSeconds, oneHour } from 'utils/time';

const SECONDS_PER_DAY = 86400;
const ONE_HOUR_IN_SECONDS = convertToSeconds(oneHour);

const sunlightTimeXPercentage = (
  type: 'dawn' | 'dusk' | 'sunrise' | 'sunset',
  index: number,
  sunlightTimes: Array<SunlightTimeDay>,
) => {
  const day = sunlightTimes?.[index];
  if (!day) return null;
  const secondsFromMidnight = day[type] - day.midnight;
  let dstChange = 0;
  // Add an hour for fall back DST
  if (day.midnightUTCOffset > day.sunsetUTCOffset) {
    dstChange = ONE_HOUR_IN_SECONDS;
  }
  // Subtract an hour for spring forward DST
  if (day.midnightUTCOffset < day.sunsetUTCOffset) {
    dstChange = ONE_HOUR_IN_SECONDS * -1;
  }
  return secondsFromMidnight / (SECONDS_PER_DAY + dstChange);
};

export default sunlightTimeXPercentage;
